import React from 'react';
import {
    Heading1,
    Heading3,
    TextLead,
    ThemedButton,
    MarkdownContent,
} from '@awarego-ui/components';
import { scoreQuestion } from './mapAiToQuestion';

export default function OwaspTrainingResults({
    question,
    blockValues,
    qaWarnings,
    onRestart,
}) {
    const { results, totalScore, correctCount } = scoreQuestion(
        question,
        blockValues
    );

    return (
        <div className="owasp-demo-results">
            <Heading1 mb={8}>Your results</Heading1>
            <div className="owasp-demo-score-circle">
                <span className="owasp-demo-score-value">{totalScore}%</span>
                <TextLead>
                    {correctCount} of {results.length} correct
                </TextLead>
            </div>

            {qaWarnings && qaWarnings.length > 0 ? (
                <div className="owasp-demo-qa-warning">
                    <Heading3>Content review note</Heading3>
                    <ul>
                        {qaWarnings.map((issue, i) => (
                            <li key={i}>{issue}</li>
                        ))}
                    </ul>
                </div>
            ) : null}

            <Heading3 mt={24} mb={16}>
                Question breakdown
            </Heading3>

            {results.map((r, i) => (
                <div
                    key={r.actionId}
                    className={`owasp-demo-result-item ${
                        r.correct ? 'correct' : 'incorrect'
                    }`}
                >
                    <Heading3 lighter>
                        {i + 1}. {r.correct ? 'Correct' : 'Incorrect'}
                    </Heading3>
                    <p className="owasp-demo-result-question">
                        <MarkdownContent>{r.title}</MarkdownContent>
                    </p>
                    <p>
                        <strong>Your answer:</strong> {r.userText}
                    </p>
                    {!r.correct ? (
                        <p>
                            <strong>Correct answer:</strong> {r.correctText}
                        </p>
                    ) : null}
                    {r.explanation ? (
                        <div className="owasp-demo-result-explanation">
                            <MarkdownContent>{r.explanation}</MarkdownContent>
                        </div>
                    ) : null}
                </div>
            ))}

            <ThemedButton
                mode="primary"
                mt={24}
                onClick={onRestart}
                text="Try another module"
            />
        </div>
    );
}
